import React, { useState } from 'react';
import { AntLocalization } from 'ante-react-kit';
import { uploadManager, useUploadQueue } from '../UploadManager';
import './floating-panels.scss';

var L = function(o) { return AntLocalization.translateText(o); };

function SvgIcon(props) {
    return (
        <svg width={props.size || 14} height={props.size || 14} viewBox="0 0 24 24"
             fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d={props.d} />
        </svg>
    );
}

var ICONS = {
    chevronUp: 'M5 15l7-7 7 7',
    chevronDown: 'M19 9l-7 7-7-7',
    close: 'M6 18L18 6M6 6l12 12',
    check: 'M5 13l4 4L19 7',
    cancel: 'M6 18L18 6M6 6l12 12',
    error: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
};

export default function UploadProgressPanel() {
    var queue = useUploadQueue();
    var [collapsed, setCollapsed] = useState(false);

    if (queue.length === 0) return null;

    var doneCount = queue.filter(function(q) { return q.status === 'done'; }).length;
    var failedCount = queue.filter(function(q) { return q.status === 'failed'; }).length;
    var totalCount = queue.length;

    var statusIcon = function(s) {
        if (s === 'done') return <SvgIcon d={ICONS.check} />;
        if (s === 'failed') return <SvgIcon d={ICONS.error} />;
        if (s === 'cancelled') return <SvgIcon d={ICONS.cancel} />;
        return null;
    };

    return (
        <div className={'med-floating-panel med-upload-panel' + (collapsed ? ' collapsed' : '')}>
            <div className="med-fp-header" onClick={function() { setCollapsed(!collapsed); }}>
                <span className="med-fp-title">
                    <SvgIcon d={collapsed ? ICONS.chevronUp : ICONS.chevronDown} />
                    Upload ({doneCount}/{totalCount}{failedCount ? ', ' + failedCount + L({ vi: ' lỗi', en: ' failed', fr: ' échecs', es: ' fallidos', id: ' gagal', ja: '件失敗', zh: ' 失败', ko: '건 실패', hi: ' विफल', ar: ' فشل' }) : ''})
                </span>
                <button className="med-fp-close" onClick={function(e) { e.stopPropagation(); uploadManager.clear(); }}>
                    <SvgIcon d={ICONS.close} />
                </button>
            </div>
            {!collapsed && (
                <div className="med-fp-body">
                    {queue.map(function(q) {
                        return (
                            <div key={q.id} className={'med-fp-item ' + q.status}>
                                <div className="med-fp-icon">{statusIcon(q.status)}</div>
                                <div className="med-fp-info">
                                    <div className="med-fp-name">{q.file.name}</div>
                                    {q.status === 'uploading' && (
                                        <progress value={q.progress} max={100} />
                                    )}
                                    {q.status === 'failed' && <div className="med-fp-error">{q.error}</div>}
                                </div>
                                {q.status !== 'done' && q.status !== 'cancelled' && (
                                    <button className="med-fp-action" onClick={function() { uploadManager.cancel(q.id); }}>
                                        <SvgIcon d={ICONS.cancel} size={12} />
                                    </button>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
